import { render, staticRenderFns } from "./mdlinx.vue?vue&type=template&id=2bdeb4d8&scoped=true&v-once=true"
import script from "./mdlinx.vue?vue&type=script&lang=js"
export * from "./mdlinx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdeb4d8",
  null
  
)

export default component.exports